module.exports = __webpack_public_path__ + "img/_super_banner.736c2b71.jpg";